import { useMutation, useQueryClient } from 'react-query';
import { getTenantIDBasedOnURL } from 'global/tenant-config';
import { useModal } from 'store/modals';
import { useContext } from 'react';
import { ALL_USERS } from '../get-all-users';
// eslint-disable-next-line max-len
import { UserAdministrationModalContext } from '../../../components/brikks/home/UserAdministration/components/UserAdministrationModal/UserAdministrationModalContext';
import { USER_PERMISSIONS_BY_EMAIL } from '../../user/permissions/permissions-by-email';
import { updateUserAPI } from './api';

export function useUpdateUser({ onSuccess } = {}) {
  const queryClient = useQueryClient();
  const tenantId = getTenantIDBasedOnURL();
  const { openModal, isModalOpen } = useModal();
  const isConfirmationModalOpen = isModalOpen('ConfirmationModal');
  const { selectedUser } = useContext(UserAdministrationModalContext);  
  const { mutate, isLoading, isSuccess, isError } = useMutation(
    ({ userId, userData }) => updateUserAPI(userId, userData),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([ALL_USERS, tenantId]);
        queryClient.invalidateQueries([USER_PERMISSIONS_BY_EMAIL, selectedUser?.email]);
        if (!isConfirmationModalOpen) {
          openModal({
            modalType: 'NotificationModal',
            modalProps: {
              type: 'success',
              description: 'updateUserSuccess',
            },
          });
        }
        if (onSuccess) {
          onSuccess();
        }

      },
      onError: () => {
        openModal({
          modalType: 'NotificationModal',
          modalProps: {
            type: 'error',
            description: 'genericErrorMessage',
          },
        });
      },
    },
  );

  return {
    updateUser: mutate,
    isLoading,
    isSuccess,
    isError,
  };
}
